(function () {
    'use strict';

    const CONFIG = {
        debug: true,
    };

    let currentUrl = window.location.href;
    let lastProductHandle = null;
    let isInitialized = false;

    function debugLog(message, data = null) {
        if (CONFIG.debug) {
            console.log('[REZ Custom]', message, data || '');
        }
    }

    function isProductPage() {
        return window.location.pathname.includes('/products/');
    }

    function isRezReloaded() {
        const rezProductHandle = window?.REZ_DATA?.current_product?.handle
        return rezProductHandle && rezProductHandle === getCurrentProductHandle();
    }

    function isCurrentProductOutOfStock() {
        const unavaiableButton = document.querySelector('.product-form__submit');
        return unavaiableButton.disabled || unavaiableButton.classList.contains('disabled');
    }

    function getCurrentProductHandle() {
        const path = window.location.pathname;
        const match = path.match(/\/products\/([^/?#]+)/);
        return match ? match[1] : null;
    }

    /**
     * Normalize Shopify GID format to extract numeric ID
     * @param {string|number} id - ID that might be in GID format like "gid://shopify/ProductVariant/44207792390191"
     * @returns {string} - Numeric ID only (e.g., "44207792390191")
     */
    function normalizeId(id) {
        if (!id) return null;

        // Convert to string for processing
        const idString = String(id);

        // If it's already a plain number, return as string
        if (/^\d+$/.test(idString)) {
            debugLog('ID já é numérico:', idString);
            return idString;
        }

        // Check if it's a Shopify GID format
        const gidMatch = idString.match(/gid:\/\/shopify\/[^\/]+\/(\d+)$/);
        if (gidMatch) {
            const numericId = gidMatch[1];
            debugLog('ID normalizado de GID:', { original: idString, normalized: numericId });
            return numericId;
        }

        // Try to extract any numeric sequence at the end
        const numericMatch = idString.match(/(\d+)$/);
        if (numericMatch) {
            const numericId = numericMatch[1];
            debugLog('ID numérico extraído:', { original: idString, normalized: numericId });
            return numericId;
        }

        // If no numeric ID found, return original
        debugLog('Não foi possível normalizar ID:', idString);
        return idString;
    }

    function cleanupExistingRezButtons() {
        // Remove apenas botões CUSTOM
        const existingCustomButtons = document.querySelectorAll('.rez-stock-notification-button[data-custom="true"]');
        existingCustomButtons.forEach(button => {
            debugLog('Removendo botão REZ custom existente');
            button.remove();
        });

        // Remove apenas modais criados pelo seu fallback (opcional manter assim)
        const existingModals = document.querySelectorAll('.rez-notify-modal, .rez-collection-notify-modal');
        existingModals.forEach(modal => {
            debugLog('Removendo modal REZ existente');
            modal.remove();
        });

        restoreBuyItNowButtons();
    }

    function restoreBuyItNowButtons() {
        const buyItNowSelectors = [
            '.shopify-payment-button',
            '.product-form__payment-container',
            '.shopify-payment-button__button',
            '.product__payment-container',
            '.product-form__buttons .shopify-payment-button',
            '[data-shopify="payment-button"]'
        ];

        buyItNowSelectors.forEach(selector => {
            const buttons = document.querySelectorAll(selector);
            buttons.forEach(button => {
                button.classList.remove('rez-hide-buy-it-now-button');
                button.style.display = '';
            });
        });
    }

    function findInjectionPoint() {
        // Add to cart button selectors (highest priority)
        const addToCartSelectors = [
            'form[action*="/cart/add"] button[type="submit"]',
            'form[action*="/cart/add"] input[type="submit"]',
            '.shopify-product-form button[type="submit"]',
            '.product-form button[type="submit"]'
        ];

        // Find add to cart button first
        for (const selector of addToCartSelectors) {
            const element = document.querySelector(selector);
            if (element) {
                debugLog('Ponto de injeção encontrado (botão add to cart):', selector);
                return {
                    element: element.parentElement || element,
                    insertType: 'after',
                    referenceElement: element
                };
            }
        }

        // Fallback to form element
        const form = document.querySelector('form[action*="/cart/add"]');
        if (form) {
            debugLog('Ponto de injeção encontrado (formulário)');
            return {
                element: form,
                insertType: 'append',
                referenceElement: null
            };
        }

        // Last resort - common product selectors
        const productSelectors = [
            '.shopify-product-form',
            '.product-form',
            '.product-single__add-to-cart',
            '.product-detail__form',
            '.product-single__meta'
        ];

        for (const selector of productSelectors) {
            const element = document.querySelector(selector);
            if (element) {
                debugLog('Ponto de injeção encontrado (fallback):', selector);
                return {
                    element: element,
                    insertType: 'append',
                    referenceElement: null
                };
            }
        }

        debugLog('Nenhum ponto de injeção encontrado');
        return null;
    }

    function createRezButton() {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'rez-stock-notification-button btn';

        // Get button config from REZ_DATA
        const btnConfig = window.REZ_DATA?.btnConfig || {};
        const buttonText = btnConfig.button_text || 'Avise-me quando disponível';
        const bgColor = btnConfig.bg_color || '#000000';
        const textColor = btnConfig.text_color || '#FFFFFF';
        const borderRadius = btnConfig.border_radius || '0';

        button.textContent = buttonText;

        // Apply styles
        Object.assign(button.style, {
            width: '100%',
            padding: '12px 20px',
            margin: '10px 0',
            backgroundColor: bgColor,
            color: textColor,
            border: 'none',
            borderRadius: borderRadius + 'px',
            cursor: 'pointer',
            fontSize: '14px',
            fontFamily: 'inherit',
            transition: 'all 0.3s ease'
        });

        // Add click event
        button.addEventListener('click', function (e) {
            e.preventDefault();
            handleRezButtonClick(e);
        });

        debugLog('Botão REZ criado com configurações:', {
            text: buttonText,
            bgColor,
            textColor,
            borderRadius
        });

        return button;
    }

    function handleRezButtonClick(e) {
        debugLog('Botão REZ clicado');

        if (window.RezModal && typeof window.RezModal.open === 'function') {
            window.RezModal.open();
            return;
        }

        const originalButton = document.querySelector('.rez-stock-notification-button:not([data-custom="true"])');
        if (originalButton && originalButton !== e.target) {
            originalButton.click();
            return;
        }

        createSimpleModal();
    }

    function createSimpleModal() {
        const modal = document.createElement('div');
        modal.className = 'rez-notify-modal __web-inspector-hide-shortcut__';
        modal.style.display = 'flex'

        const formConfig = window.REZ_DATA?.formConfig || {};
        const product = window.REZ_DATA?.current_product;
        const productVariants = product?.variants?.nodes || {};

        const content = `
          <div class="rez-notify-modal-backdrop"></div>
          <div class="rez-notify-modal-content">
            <div class="rez-notify-modal-header">
              <div class="rez-notify-bell-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
              <path d="M12 22c1.1 0 2-.9 2-2h-4c0 1.1.9 2 2 2zm6-6v-5c0-3.07-1.64-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.63 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2z"></path>
            </svg>
              </div>
              <h2>${formConfig?.header || 'Avise-me'}</h2>
              <button class="rez-notify-close-btn">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
              <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"></path>
            </svg>
              </button>
            </div>
            <div class="rez-notify-modal-body">
              <p style="margin: 0px;">${formConfig?.cf_description || 'Seja notificado quando este produto estiver novamente em estoque!'}</p>

              <div class="rez-notify-product-section">
            <div class="rez-notify-product-label">Product name</div>
            <div class="rez-notify-product-value">${product?.title || 'Este produto'}</div>
              </div>
              ${productVariants.length > 0 ? `
            <div class="rez-notify-variant-dropdown">
              <select class="rez-notify-variant-select">
                ${productVariants.map(variant => `
                  <option value="${normalizeId(variant.id)}">${variant.title || `Variante ${normalizeId(variant.id)}`}</option>
                `).join('')}
              </select>
            </div>
              ` : ''}
              <div class="rez-notify-input-container">
            <input type="email" placeholder="E-mail" class="rez-notify-email-input" value="">
            <div class="rez-notify-error-message"></div>
              </div>

              <button class="rez-notify-submit-btn" style="border-radius: 0px; color: #FDFAEF; background-color: #000000;">
            ${formConfig?.btn_text || 'Avise-me quando disponível'}
              </button>
              <p class="rez-notify-terms">.</p>
            </div>
          </div>
        `;

        modal.innerHTML = content;
        document.body.appendChild(modal);

        // Attach event listeners similar to original REZ modal
        attachModalEventListeners(modal);

        debugLog('Modal simples criado');
    }

    function attachModalEventListeners(modal) {
        // Close button handler
        const closeBtn = modal.querySelector('.rez-notify-close-btn');
        if (closeBtn) {
            closeBtn.addEventListener('click', () => {
                debugLog('Botão fechar clicado');
                modal.remove();
            });
        }

        // Backdrop click handler
        const backdrop = modal.querySelector('.rez-notify-modal-backdrop');
        if (backdrop) {
            backdrop.addEventListener('click', () => {
                debugLog('Backdrop clicado');
                modal.remove();
            });
        }

        // Email input handler
        const emailInput = modal.querySelector('.rez-notify-email-input');
        if (emailInput) {
            emailInput.addEventListener('input', (e) => {
                debugLog('Email input changed:', e.target.value);
                clearModalError(modal);
            });
        }

        // Submit button handler
        const submitButton = modal.querySelector('.rez-notify-submit-btn');
        if (submitButton) {
            submitButton.addEventListener('click', (e) => {
                e.preventDefault();
                debugLog('Submit button clicado');
                handleModalSubmit(modal);
            });
        }

        // Variant selector handler
        const variantSelect = modal.querySelector('.rez-notify-variant-select');
        if (variantSelect) {
            variantSelect.addEventListener('change', (e) => {
                debugLog('Variant changed:', e.target.value);
                // Update current variant logic if needed
            });
        }

        // ESC key handler
        const handleEscKey = (e) => {
            if (e.key === 'Escape') {
                debugLog('ESC pressionado');
                modal.remove();
                document.removeEventListener('keydown', handleEscKey);
            }
        };
        document.addEventListener('keydown', handleEscKey);

        debugLog('Event listeners attached to modal');
    }

    function clearModalError(modal) {
        const errorElement = modal.querySelector('.rez-notify-error-message');
        if (errorElement) {
            errorElement.textContent = '';
        }
    }

    function showModalError(modal, message) {
        const errorElement = modal.querySelector('.rez-notify-error-message');
        if (errorElement) {
            errorElement.textContent = message;
            errorElement.style.color = '#e74c3c';
        }
    }

    function validateEmail(email) {
        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(email).toLowerCase());
    }

    function handleModalSubmit(modal) {
        const emailInput = modal.querySelector('.rez-notify-email-input');
        const variantSelect = modal.querySelector('.rez-notify-variant-select');

        if (!emailInput) {
            debugLog('Email input não encontrado');
            return;
        }

        const email = emailInput.value.trim();

        // Validate email
        if (!email) {
            showModalError(modal, 'Por favor, insira seu e-mail');
            return;
        }

        if (!validateEmail(email)) {
            showModalError(modal, 'Por favor, insira um e-mail válido');
            return;
        }

        // Get product data
        const product = window.REZ_DATA?.current_product;
        const storeData = window.REZ_DATA?.storeData;

        if (!product) {
            showModalError(modal, 'Erro: dados do produto não encontrados');
            return;
        }

        // Get selected variant ID and normalize it
        let selectedVariantId = null;
        let selectedVariantTitle = '';

        if (variantSelect) {
            selectedVariantId = normalizeId(variantSelect.value);
            selectedVariantTitle = variantSelect.options[variantSelect.selectedIndex]?.text || '';
        }

        // Prepare submission data with normalized IDs
        const submissionData = {
            email: email,
            product_id: normalizeId(product.id),
            product_name: product.title,
            store_id: normalizeId(storeData?.id),
            variant_id: selectedVariantId,
            variant_title: selectedVariantTitle,
        };

        debugLog('Enviando dados:', submissionData);

        // Show loading state
        const submitButton = modal.querySelector('.rez-notify-submit-btn');
        if (submitButton) {
            submitButton.textContent = 'Enviando...';
            submitButton.disabled = true;
        }

        // Submit to REZ endpoint
        submitToRez(submissionData)
            .then(() => {
                debugLog('Submissão bem-sucedida');
                showConfirmationView(modal);
            })
            .catch((error) => {
                debugLog('Erro na submissão:', error);
                showModalError(modal, 'Erro ao enviar. Tente novamente.');

                // Reset button
                if (submitButton) {
                    const formConfig = window.REZ_DATA?.formConfig || {};
                    submitButton.textContent = formConfig.btn_text || 'Avise-me quando disponível';
                    submitButton.disabled = false;
                }
            });
    }

    async function submitToRez(data) {
        try {
            const response = await fetch('/apps/rez/bis/product', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data)
            });

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const result = await response.json();
            return result;
        } catch (error) {
            debugLog('Erro no fetch:', error);
            throw error;
        }
    }

    function showConfirmationView(modal) {
        const formConfig = window.REZ_DATA?.formConfig || {};

        // Update modal header
        const modalHeader = modal.querySelector('.rez-notify-modal-header');
        if (modalHeader) {
            modalHeader.innerHTML = `
                <div class="rez-notify-header-spacer"></div>
                <button class="rez-notify-close-btn">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                        <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/>
                    </svg>
                </button>
            `;
        }

        // Update modal body with confirmation
        const modalBody = modal.querySelector('.rez-notify-modal-body');
        if (modalBody) {
            modalBody.innerHTML = `
                <div class="rez-notify-confirmation">
                    <div class="rez-notify-check-icon">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="48" height="48">
                            <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z" fill="currentColor"/>
                        </svg>
                    </div>
                    <h2>${formConfig.cf_header || 'Obrigado!'}</h2>
                    <p>${formConfig.cf_description || 'Você será notificado quando este produto estiver disponível novamente.'}</p>
                </div>
            `;
        }

        // Reattach close button listener for confirmation view
        const newCloseBtn = modal.querySelector('.rez-notify-close-btn');
        if (newCloseBtn) {
            newCloseBtn.addEventListener('click', () => {
                debugLog('Botão fechar clicado (confirmação)');
                modal.remove();
            });
        }

        debugLog('Tela de confirmação exibida');
    }

    function injectRezButton() {
        if (!isCurrentProductOutOfStock()) {
            debugLog('Produto em estoque, não injeta botão');
            return false;
        }

        // ✅ Se o app REZ já colocou o botão, não injeta outro
        const originalRezButton = document.querySelector('.rez-stock-notification-button:not([data-custom="true"])');
        if (originalRezButton) {
            debugLog('Botão original REZ já existe, não injetando o custom');
            return false;
        }

        // ✅ Evita duplicar o custom
        const customAlreadyThere = document.querySelector('.rez-stock-notification-button[data-custom="true"]');
        if (customAlreadyThere) {
            debugLog('Botão custom já existe, não reinjeta');
            return false;
        }

        const injectionPoint = findInjectionPoint();
        if (!injectionPoint) {
            debugLog('Nenhum ponto de injeção encontrado');
            return false;
        }

        const button = createRezButton();
        button.setAttribute('data-custom', 'true'); // Mark as custom button

        try {
            switch (injectionPoint.insertType) {
                case 'after':
                    if (injectionPoint.referenceElement) {
                        injectionPoint.referenceElement.parentNode.insertBefore(button, injectionPoint.referenceElement.nextSibling);
                    } else {
                        injectionPoint.element.appendChild(button);
                    }
                    break;
                case 'before':
                    if (injectionPoint.referenceElement) {
                        injectionPoint.referenceElement.parentNode.insertBefore(button, injectionPoint.referenceElement);
                    } else {
                        injectionPoint.element.insertBefore(button, injectionPoint.element.firstChild);
                    }
                    break;
                case 'append':
                default:
                    injectionPoint.element.appendChild(button);
                    break;
            }

            // Hide buy it now buttons when out of stock
            hideBuyItNowButtons();

            debugLog('Botão REZ injetado com sucesso');
            return true;

        } catch (error) {
            debugLog('Erro ao injetar botão:', error);
            return false;
        }
    }

    function hideBuyItNowButtons() {
        const buyItNowSelectors = [
            '.shopify-payment-button',
            '.product-form__payment-container',
            '.shopify-payment-button__button',
            '.product__payment-container',
            '.product-form__buttons .shopify-payment-button',
            '[data-shopify="payment-button"]'
        ];

        buyItNowSelectors.forEach(selector => {
            const buttons = document.querySelectorAll(selector);
            buttons.forEach(button => {
                button.style.display = 'none';
                button.classList.add('rez-hide-buy-it-now-button');
                debugLog('Botão Buy it Now escondido:', selector);
            });
        });
    }

    function setupUrlMonitoring() {
        const originalPushState = history.pushState;
        const originalReplaceState = history.replaceState;

        history.pushState = function () {
            originalPushState.apply(history, arguments);
            handleUrlChange();
        };

        history.replaceState = function () {
            originalReplaceState.apply(history, arguments);
            handleUrlChange();
        };

        window.addEventListener('popstate', handleUrlChange);

        const observer = new MutationObserver(function (mutations) {
            let shouldCheck = false;

            mutations.forEach(function (mutation) {
                if (mutation.type === 'childList' || mutation.type === 'subtree') {
                    shouldCheck = true;
                }
            });

            if (shouldCheck) {
                debugLog('Mudanças detectadas no DOM, verificando necessidade de reinicialização');
                handleUrlChange()
            }
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true
        });

        debugLog('Monitoramento de URL configurado');
    }

    function handleUrlChange() {
        if (!isCurrentProductOutOfStock()) return;

        const newUrl = window.location.href;
        const newProductHandle = getCurrentProductHandle();

        if (newUrl !== currentUrl || newProductHandle !== lastProductHandle) {
            debugLog('Mudança de URL detectada:', {
                old: currentUrl,
                new: newUrl,
                oldHandle: lastProductHandle,
                newHandle: newProductHandle
            });

            if (!isRezReloaded()) {
                cleanupExistingRezButtons();

                getProductData(newProductHandle).then(newProductData => {
                    window.REZ_DATA.current_product = newProductData;
                    debugLog(`Reinicializando REZ para novo ${newProductData.handle}:`, window.REZ_DATA.current_product);

                    setTimeout(() => {
                        injectRezButton();
                    }, 250);
                });
            } else {
                debugLog('Reinicialização não necessária, REZ já recarregado');
            }

            currentUrl = newUrl;
            lastProductHandle = newProductHandle;
        }
    }

    async function getProductData(productHandle) {
        try {
            const data = await window.getProductData({ handle: productHandle });
            debugLog("Product data fetched:", data.product);

            return data.product;
        } catch (error) {
            debugLog("Error fetching product data:", error);
        }
    }


    function initialize() {
        if (isInitialized || !isProductPage()) return;

        debugLog('Inicializando script customizado REZ');

        setupUrlMonitoring();
        monitorVariantSelection();
    
        // Checar se a primeira variante já está esgotada
        setTimeout(() => {
            if (isVariantOutOfStock()) {
                injectRezButton();
            }
        }, 200);

        isInitialized = true;
        debugLog('Script customizado REZ inicializado');
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initialize);
    } else {
        initialize();
    }

    function monitorVariantSelection() {
        const sizeInputs = document.querySelectorAll('input[type="radio"][name*="size"], input[type="radio"][name*="option"]');

        sizeInputs.forEach(input => {
            input.addEventListener('change', () => {
                setTimeout(() => {
                    cleanupExistingRezButtons();

                    if (isVariantOutOfStock()) {
                        injectRezButton();
                    }
                }, 150); // Espera DOM atualizar após clique
            });
        });

        debugLog('Listeners adicionados às variantes');
    }

    function isVariantOutOfStock() {
        const addToCartButton = document.querySelector('.product-form__submit');
        return addToCartButton?.disabled || addToCartButton?.classList.contains('disabled');
    }

    window.RezCustom = {
        debug: (enable) => { CONFIG.debug = enable; },
        getCurrentHandle: getCurrentProductHandle,
        isProductPage: isProductPage,
        checkData: () => window.REZ_DATA,
        injectButton: injectRezButton,
        cleanup: cleanupExistingRezButtons,
        isOutOfStock: isCurrentProductOutOfStock,
        normalizeId: normalizeId
    };

    debugLog('Script customizado REZ carregado');
})();
